import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpShort = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 13L10 7L16 13", stroke: "#2F3337", strokeWidth: 1.67, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowUpShort);
export { ForwardRef as ReactComponent };
